import { ConsentTracking } from '@dev/ee-api/ee-api-models';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ChangeTrackingConsent } from '@/components/Contacts/CommonActions/ChangeTrackingConsent';
import { useEntityRuleForFiltration } from '@/components/Contacts/Group/hooks';
import { ContactsBulkUpdateStart } from '@/store/contacts/actions';
import { ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { ContactTableContext } from '../../context';

export const useChangeConcent = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { selectedRows, selectedAll } = useContext(ContactTableContext);
    const { filtrationRuleWithQuery } = useEntityRuleForFiltration();
    const changeConsentTracking = (email?: string): void => {
        const emailsToChangeConsent = !!email ? [email] : selectedRows;

        const changedContacts = {
            emails: selectedAll ? null : emailsToChangeConsent,
            field: 'ConsentTracking',
            value: '',
            rule: selectedAll ? filtrationRuleWithQuery : null,
        };

        let newConsentTracking = ConsentTracking.Unknown;

        const changeConsentTracking = (newConsent: ConsentTracking) => {
            newConsentTracking = newConsent;
        };

        const params: ShowDialogParams = {
            title: t('changeconsenttracking'),
            confirmLabel: t('save'),
            onClickConfirm: (): void => {
                const updatedContacts = { ...changedContacts, value: newConsentTracking };
                dispatch(ContactsBulkUpdateStart(updatedContacts));
            },
            cancelLabel: t('cancel'),
            body: <ChangeTrackingConsent params={changedContacts} changeConsentTracking={changeConsentTracking} />,
        };

        dispatch(ShowDialog(params));
    };
    return { changeConsentTracking };
};
